import './bootstrap-2024-10';
import './tracking';

// load image files
import.meta.glob([
    '../images/**',
]);

function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
window.sleep = sleep;
